module.exports = __webpack_public_path__ + "img/icon-mobile-sign.d313d760.svg";